import { render, staticRenderFns } from "./AreaDoAssociadoConfirmaCadastro.vue?vue&type=template&id=56deae23&"
import script from "./AreaDoAssociadoConfirmaCadastro.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoConfirmaCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports